import { AfterViewInit, Component, OnInit } from '@angular/core';
import { KTUtil } from '../../../../../assets/js/components/util';
import KTLayoutAsideToggle from '../../../../../assets/js/layout/base/aside-toggle';
import KTLayoutStickyCard from '../../../../../assets/js/layout/base/sticky-card';
import KTLayoutStretchedCard from '../../../../../assets/js/layout/base/stretched-card';
import { LayoutService } from '../../core/services/layout.service';
import KTLayoutBrand from '../../../../../assets/js/layout/base/brand';
import KTLayoutAside from '../../../../../assets/js/layout/base/aside';
import KTLayoutAsideMenu from '../../../../../assets/js/layout/base/aside-menu';

@Component({
  selector: 'sc-scripts-init',
  templateUrl: './scripts-init.component.html'
})
export class ScriptsInitComponent implements OnInit, AfterViewInit {
  asideSelfMinimizeToggle = false;

  constructor(private readonly layout: LayoutService) { }

  ngOnInit(): void {
    this.asideSelfMinimizeToggle = this.layout.getProp(
      'aside.self.minimize.toggle'
    );
  }

  ngAfterViewInit() {
    KTUtil.ready(() => {
      // Init Brand Panel For Logo
      KTLayoutBrand.init('sc_brand');
      // Init Aside
      KTLayoutAside.init('sc_aside');
      // Init Aside Menu
      KTLayoutAsideMenu.init('sc_aside_menu');

      if (this.asideSelfMinimizeToggle) {
        // Init Aside Menu Toggle
        KTLayoutAsideToggle.init('sc_aside_toggle');
      }

      // Init Sticky Card
      KTLayoutStickyCard.init('sc_page_sticky_card');
      // Init Stretched Card
      KTLayoutStretchedCard.init('sc_page_stretched_card');
    });
  }

}
